import { Image, RhLink } from "@components";
import GenericImage from './generic-person.webp';
import { BaseInducteeInfoFragment } from "@/__generated__/graphql";

import className from "classnames/bind";
import styles from "./InducteeCard.module.scss";
const cx = className.bind(styles);

type Inductee = BaseInducteeInfoFragment;

interface InducteeCardProps {
  className?: string;
  showCategory?: boolean;
  inductee: Inductee;
}

export default function InducteeCard(props: InducteeCardProps) {
  const { inductee, className, showCategory } = props;
  const { uri, title, inducteeData: { inducteeClass, category }, pageData: { featuredImage } } = inductee;
  return (
    <RhLink href={uri} className={`${cx(["inductee-card", className])} inductee-card`}>
      <div className={`${cx("content-wrapper")} content-wrapper`}>
        <div className={cx("image-wrapper", { "no-image": !featuredImage })}>
          {featuredImage ? (
            <Image image={featuredImage} className={cx("image")} />
          ) : (
            <img
              src={GenericImage.src}
              alt={title}
              className={cx("image")}
            />
          )}
        </div>
        <div className={cx("text-wrapper")}>
          <p className={cx("name", "text-m")}>{title}</p>
          <div className={cx("pills")}>
            <p className={cx("pill", "class", "tag-s")}>
              {inducteeClass?.[0]?.slug}
            </p>
            { showCategory && category?.map((cat, index) => (
              <p className={cx("pill", "category", "tag-s")} key={index}>
                {cat}
              </p>
            ))}
          </div>
        </div>
      </div>
    </RhLink>
  );
}
